<template>
  <div class="designtool" >
    <el-container style="height: 100%" direction="vertical">
      <!--设计工具头部-->
      <el-header>
         <the-hander></the-hander>
      </el-header>
      <el-container style="overflow: auto">
        <!--设计工具左侧-->
        <el-aside width="20%">
          <the-aside></the-aside>
        </el-aside>
        <!--设计工具右侧-->
        <el-main>
          <the-main></the-main>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>



<script>
import TheHander from '../pages/designtoolpages/TheHander'
import TheAside from '../pages/designtoolpages/TheAside'
import TheMain from '../pages/designtoolpages/TheMain'
export default {
  name: 'Designtool',
  components: {
    TheHander,TheAside,TheMain
  },
  data () {
    return {
      isCollapse: false
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}
</script>
<style scoped>
  .designtool{
    height: 100%;
    overflow: hidden;
  }
  .designtool>>>.el-header, .el-footer {
    background-image: linear-gradient(-90deg,
    #1f5199 0%,
    #0e2f99 50%,
    #2c2899 100%),
    linear-gradient(
      #27bdff,
      #27bdff);
    color: #333;
    text-align: center;
    line-height: 33px;
    height: 33px !important;
  }
  .el-aside {
    background-color: #b5b5b5;
    color: #333;
    text-align: center;
    padding-right: 5px;
    overflow: auto;
  }
  .el-main {
    background-color: #fff;
    color: #333;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Designtool.vue